/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataJobEnum } from './DataJobEnum';
import { DataJobEnumFromJSON, DataJobEnumFromJSONTyped, DataJobEnumToJSON } from './DataJobEnum';
import type { DatasetPipelineStatus } from './DatasetPipelineStatus';
import {
  DatasetPipelineStatusFromJSON,
  DatasetPipelineStatusFromJSONTyped,
  DatasetPipelineStatusToJSON,
} from './DatasetPipelineStatus';
import type { AiModelName } from './AiModelName';
import { AiModelNameFromJSON, AiModelNameFromJSONTyped, AiModelNameToJSON } from './AiModelName';
import type { Dataset } from './Dataset';
import { DatasetFromJSON, DatasetFromJSONTyped, DatasetToJSON } from './Dataset';
import type { PerturbedDataset } from './PerturbedDataset';
import { PerturbedDatasetFromJSON, PerturbedDatasetFromJSONTyped, PerturbedDatasetToJSON } from './PerturbedDataset';
import type { DatasetPipelineInferencer } from './DatasetPipelineInferencer';
import {
  DatasetPipelineInferencerFromJSON,
  DatasetPipelineInferencerFromJSONTyped,
  DatasetPipelineInferencerToJSON,
} from './DatasetPipelineInferencer';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPipelineList
 */
export interface DatasetPipelineList {
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineList
   */
  readonly id: number;
  /**
   *
   * @type {AiModelName}
   * @memberof DatasetPipelineList
   */
  readonly aiModel: AiModelName;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPipelineList
   */
  taskType?: TaskTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineList
   */
  generationInputs?: number | null;
  /**
   *
   * @type {DatasetPipelineInferencer}
   * @memberof DatasetPipelineList
   */
  inferencer: DatasetPipelineInferencer;
  /**
   *
   * @type {Array<Perturbation>}
   * @memberof DatasetPipelineList
   */
  readonly perturbations: Array<Perturbation>;
  /**
   *
   * @type {Dataset}
   * @memberof DatasetPipelineList
   */
  readonly dataset: Dataset;
  /**
   *
   * @type {Array<PerturbedDataset>}
   * @memberof DatasetPipelineList
   */
  readonly perturbedDatasets: Array<PerturbedDataset>;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineList
   */
  taskName?: string | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineList
   */
  readonly progress: number | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineList
   */
  readonly startTime: Date | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineList
   */
  readonly endTime: Date | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineList
   */
  readonly estimatedTime: number | null;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineList
   */
  readonly errorMessage: string | null;
  /**
   *
   * @type {DataJobEnum}
   * @memberof DatasetPipelineList
   */
  readonly dataJob: DataJobEnum | null;
  /**
   *
   * @type {DatasetPipelineStatus}
   * @memberof DatasetPipelineList
   */
  readonly status: DatasetPipelineStatus | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineList
   */
  readonly timestamp: Date;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineList
   */
  readonly perturbedDatasetsWithPredictionsPct: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineList
   */
  readonly hasAssessments: boolean;
}

/**
 * Check if a given object implements the DatasetPipelineList interface.
 */
export function instanceOfDatasetPipelineList(value: object): value is DatasetPipelineList {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  if (!('perturbations' in value) || value['perturbations'] === undefined) return false;
  if (!('dataset' in value) || value['dataset'] === undefined) return false;
  if (!('perturbedDatasets' in value) || value['perturbedDatasets'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  if (!('startTime' in value) || value['startTime'] === undefined) return false;
  if (!('endTime' in value) || value['endTime'] === undefined) return false;
  if (!('estimatedTime' in value) || value['estimatedTime'] === undefined) return false;
  if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
  if (!('dataJob' in value) || value['dataJob'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('perturbedDatasetsWithPredictionsPct' in value) || value['perturbedDatasetsWithPredictionsPct'] === undefined)
    return false;
  if (!('hasAssessments' in value) || value['hasAssessments'] === undefined) return false;
  return true;
}

export function DatasetPipelineListFromJSON(json: any): DatasetPipelineList {
  return DatasetPipelineListFromJSONTyped(json, false);
}

export function DatasetPipelineListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineList {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: AiModelNameFromJSON(json['ai_model']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    generationInputs: json['generation_inputs'] == null ? undefined : json['generation_inputs'],
    inferencer: DatasetPipelineInferencerFromJSON(json['inferencer']),
    perturbations: (json['perturbations'] as Array<any>).map(PerturbationFromJSON),
    dataset: DatasetFromJSON(json['dataset']),
    perturbedDatasets: (json['perturbed_datasets'] as Array<any>).map(PerturbedDatasetFromJSON),
    taskName: json['task_name'] == null ? undefined : json['task_name'],
    progress: json['progress'],
    startTime: json['start_time'] == null ? null : new Date(json['start_time']),
    endTime: json['end_time'] == null ? null : new Date(json['end_time']),
    estimatedTime: json['estimated_time'],
    errorMessage: json['error_message'],
    dataJob: DataJobEnumFromJSON(json['data_job']),
    status: DatasetPipelineStatusFromJSON(json['status']),
    timestamp: new Date(json['timestamp']),
    perturbedDatasetsWithPredictionsPct: json['perturbed_datasets_with_predictions_pct'],
    hasAssessments: json['has_assessments'],
  };
}

export function DatasetPipelineListToJSON(
  value?: Omit<
    DatasetPipelineList,
    | 'id'
    | 'aiModel'
    | 'perturbations'
    | 'dataset'
    | 'perturbedDatasets'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'errorMessage'
    | 'dataJob'
    | 'status'
    | 'timestamp'
    | 'perturbedDatasetsWithPredictionsPct'
    | 'hasAssessments'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    generation_inputs: value['generationInputs'],
    inferencer: DatasetPipelineInferencerToJSON(value['inferencer']),
    task_name: value['taskName'],
  };
}
